const ENVIO_ENVIADO = 'EE'
const ENVIO_RECIBIDO = 'ER'
const RECEPCION_PENDIENTE = 'RP'
const RECEPCION_RECIBIDO = 'RR'

const __dictionary = {
  [ENVIO_ENVIADO]: {
    id: ENVIO_ENVIADO,
    nombre: 'ENVIADO'
  },
  [ENVIO_RECIBIDO]: {
    id: ENVIO_RECIBIDO,
    nombre: 'RECIBIDO'
  },
  [RECEPCION_PENDIENTE]: {
    id: RECEPCION_PENDIENTE,
    nombre: 'PENDIENTE'
  },
  [RECEPCION_RECIBIDO]: {
    id: RECEPCION_RECIBIDO,
    nombre: 'RECIBIDO'
  }
}

const __arrayEnvio = [__dictionary[ENVIO_ENVIADO], __dictionary[ENVIO_RECIBIDO]]

const __arrayRecepcion = [__dictionary[RECEPCION_PENDIENTE], __dictionary[RECEPCION_RECIBIDO]]

export default Object.freeze({
  ENVIO_ENVIADO,
  ENVIO_RECIBIDO,
  RECEPCION_PENDIENTE,
  RECEPCION_RECIBIDO,
  __dictionary,
  __arrayEnvio,
  __arrayRecepcion
})
